// ============================================================================
// CASE ACCOUNT SERVICE — Phase 9b-2
// ============================================================================
// Read returns a flat list scoped to a single case (no pagination — a case
// rarely has more than a handful of accounts).

import { get, post, put, del } from '../client/axiosClient';
import { caseAccountEndpoints } from '../endpoints/caseAccount.endpoints';
import type { ApiResponse, EmptyResponse, ID } from '../types';
import type {
  CaseAccount,
  CreateCaseAccountRequest,
  UpdateCaseAccountRequest,
} from '../types/caseAccount.types';

class CaseAccountService {
  async getByCase(caseId: ID): Promise<ApiResponse<CaseAccount[]>> {
    const response = await get<ApiResponse<CaseAccount[]>>(
      caseAccountEndpoints.byCase(caseId),
    );
    return response.data;
  }

  async getById(id: ID): Promise<ApiResponse<CaseAccount>> {
    const response = await get<ApiResponse<CaseAccount>>(
      caseAccountEndpoints.getById(id),
    );
    return response.data;
  }

  async create(data: CreateCaseAccountRequest): Promise<ApiResponse<CaseAccount>> {
    const response = await post<ApiResponse<CaseAccount>>(
      caseAccountEndpoints.create(),
      data,
    );
    return response.data;
  }

  async update(id: ID, data: UpdateCaseAccountRequest): Promise<ApiResponse<CaseAccount>> {
    const response = await put<ApiResponse<CaseAccount>>(
      caseAccountEndpoints.update(id),
      data,
    );
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    const response = await del<EmptyResponse>(caseAccountEndpoints.delete(id));
    return response.data;
  }

  async markPrimary(id: ID): Promise<EmptyResponse> {
    const response = await post<EmptyResponse>(
      caseAccountEndpoints.markPrimary(id),
      {},
    );
    return response.data;
  }
}

export const caseAccountService = new CaseAccountService();
export default caseAccountService;
